<template>
  <div class="login-card">
    <!-- 右上方切换账号登录与扫码登录 -->
    <div class="triangle" @click="changeQrLogin">
      <img
        v-if="useQrLogin"
        src="../../assets/images/common/icon-phone.png"
        alt=""
      />
      <img v-else src="../../assets/images/common/icon-qr.png" alt="" />
      <el-tag class="tip" type="primary">
        {{ useQrLogin ? '账号密码登录' : '扫码登录更安全' }}
      </el-tag>
    </div>

    <div class="login-wrap">
      <div v-if="useQrLogin" class="title default">手机微信扫码登录</div>
      <!-- 左右滑动登录标题 -->
      <div
        v-else
        class="flex-center row-around col-top card-title title m-h-22"
      >
        <div
          v-for="(way, index) in loginWay"
          :key="index"
          class="card-title-item"
          :class="{ active: currentWay === way.value }"
          @click="onSideClick(way.value)"
        >
          {{ way.label }}
        </div>

        <div
          class="card-title-line"
          :style="{ left: `${currentWay * 170 + 50}px` }"
        ></div>
      </div>

      <we-chat-login
        v-if="useQrLogin"
        :jump-path-by-identity="jumpPathByIdentity"
      />

      <account-login
        v-else-if="currentWay === 0"
        class="m-l-22"
        :jump-path-by-identity="jumpPathByIdentity"
      />

      <mobile-login
        v-else-if="currentWay === 1"
        class="m-l-22"
        :jump-path-by-identity="jumpPathByIdentity"
      />
    </div>

    <!-- 注册引导 -->
    <div
      class="register-guide"
      :class="{
        'register-guide-jxic': platformConfig.alias === 'jxic',
        'register-guide-useQrLogin': useQrLogin
      }"
    >
      <div class="register-guide-item">
        <el-button type="text" @click="onRegister">注册</el-button>
        <!--<el-button-->
        <!--  v-if="platformConfig.alias !== 'jxic'"-->
        <!--  type="text"-->
        <!--  class="expert-register"-->
        <!--  @click="onExpertRegister"-->
        <!--&gt;评审专家注册</el-button>-->
      </div>
      <div v-if="currentWay === 0 && !useQrLogin" class="register-guide-item">
        <!-- 忘记密码 -->
        <el-button type="text" :underline="false" @click="onForget">
          忘记密码
        </el-button>
      </div>
    </div>

    <!-- 轮播图 -->
    <banner-list
      v-if="platformConfig.needValueAdd"
      class="banner-list"
      :class="{ 'banner-list-useQrLogin': useQrLogin }"
    />
    <div v-else style="height: 33px"></div>
  </div>
</template>

<script>
// 组件
import AccountLogin from '@/views/login/components/AccountLogin'
import MobileLogin from '@/views/login/components/MobileLogin'
import WeChatLogin from '@/views/login/components/WeChatLogin'
import BannerList from '@/views/login/components/BannerList'

// 后端api
import { getUserIdentityApi } from '@/api/user'

// 工具函数
import { mapGetters } from 'vuex'
import Cookies from 'js-cookie'
import { addQueryToUrl } from '@/utils/utils'

export default {
  name: 'Login',
  components: {
    AccountLogin,
    MobileLogin,
    WeChatLogin,
    BannerList
  },

  data() {
    return {
      // 获取returnUrl
      returnUrl: this.$route.query.returnUrl,
      // 登录方式数组
      loginWay: [
        { label: '密码登录', value: 0 },
        { label: '短信登录', value: 1 }
      ],
      // 当前登录方式对应的值
      currentWay: 0,
      useQrLoginTemp: ''
    }
  },

  computed: {
    ...mapGetters('system', ['platformConfig']),

    useQrLogin: {
      get() {
        if (typeof this.useQrLoginTemp === 'string') {
          return this.platformConfig.defaultLoginMethod === 'wechat'
        } else {
          return this.useQrLoginTemp
        }
      },
      set(val) {
        this.useQrLoginTemp = val
      }
    },

    // 更换滑动过渡效果
    transitionName() {
      return this.currentWay === 0 ? 'fade-transform-right' : 'fade-transform'
    }
  },

  methods: {
    /**
     * 侧边登录方式切换事件处理函数
     * @param {number} value 登录方式对应的value值
     */
    onSideClick(value) {
      this.currentWay = value
    },

    // 跳转至企业注册页面
    onRegister() {
      this.$router.push({ name: 'Register' })
    },

    // 跳转至专家注册页面
    onExpertRegister() {
      this.$router.push({ name: 'ExpertRegister' })
    },

    // 切换扫码登录或账号登录
    changeQrLogin() {
      this.useQrLogin = !this.useQrLogin
    },

    /**
     * 忘记密码点击事件
     */
    onForget() {
      this.$router.push({ name: 'Forget' })
    },

    /**
     * 验证用户的登录角色，决定跳转路径
     * @param ac {String} 登录验证参数
     * @returns {Promise<unknown>}
     */
    jumpPathByIdentity(ac) {
      if (ac) {
        Cookies.set('X-JCZH-AC', ac, {
          domain: `.${window.location.hostname
            .split('.')
            .slice(-2)
            .join('.')}`
        })
      }

      return new Promise((resolve, reject) => {
        getUserIdentityApi()
          .then(res => {
            if (this.returnUrl) {
              window.location.href = addQueryToUrl(this.returnUrl, { ac: ac })
            } else if (res?.data?.employee && res?.data?.expert) {
              this.$router.push({
                name: 'LoginNavigate',
                query: { ac: ac }
              })
            } else if (res?.data?.employee) {
              window.location.href = addQueryToUrl(
                process.env.VUE_APP_LOGIN_JUMP_URL,
                { ac: ac }
              )
            } else if (res?.data?.expert) {
              window.location.href = addQueryToUrl(
                process.env.VUE_APP_EXPERT_URL,
                { ac: ac }
              )
            } else {
              // window.location.href = addQueryToUrl(
              //   this.platformConfig.portalUrl,
              //   { ac: ac }
              // )
              this.$router.push({
                name: 'LoginNavigate',
                query: { ac: ac }
              })
            }
            resolve()
          })
          .catch(err => {
            this.$message.error('获取用户身份失败')
            reject(err)
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login-card {
  .triangle {
    position: absolute;
    top: 0;
    right: 0;
    width: 56px;
    height: 56px;
    cursor: pointer;

    &::after {
      content: '';
      display: block;
      width: 0;
      height: 0;
      border-top: 56px solid $primary-color;
      border-left: 56px solid transparent;
      position: absolute;
      z-index: 1;
    }

    img {
      width: 36px;
      position: absolute;
      top: 8px;
      right: 8px;
      z-index: 2;
    }

    .tip {
      position: absolute;
      top: 20px;
      right: 60px;
      z-index: 99;

      // 侧边三角
      &:after {
        display: block;
        content: '';
        border-width: 8px 8px 8px 8px;
        border-style: solid;
        border-color: transparent transparent transparent $primary-fourth-color;

        /* 定位 */
        position: absolute;
        right: -17px;
        top: 50%;
        transform: translateY(-50%);
        z-index: 99;
      }
    }
  }

  .login-wrap {
    width: 100%;
    margin-top: 44px;
    .default {
      text-align: center;
      font-size: 18px;
      margin-bottom: 12px;
    }
  }

  .card-title {
    position: relative;
    height: 32px;

    .card-title-item {
      cursor: pointer;

      &.active {
        color: $primary-color;
      }
    }

    .card-title-line {
      width: 70px;
      height: 3px;
      background-color: $primary-color;
      position: absolute;
      bottom: 0;
      left: 0;
      transition: all 0.5s;
    }
  }

  .register-guide {
    width: calc(100% - 44px);
    margin-top: 16px;
    font-size: 16px;
    margin-left: 22px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .expert-register {
      border-left: 1px solid $info-fourth-color;
      padding-left: 10px;
    }

    &-jxic {
      display: flex;
      justify-content: space-around;

      .register-guide-item {
        width: 72px;
        text-align: center;
      }
    }
  }
  .register-guide-useQrLogin {
    justify-content: center;
    margin-top: 2px;

    .register-guide-item {
      width: auto;
    }
  }
  .banner-list {
    width: 340px;
    height: 80px;
    margin-left: 22px;
    margin-top: 24px;
  }
  .banner-list-useQrLogin {
    margin-top: 20px;
  }
}
</style>
